import AmplitudeService from '@/utils/services/amplitude';

export default {
  install(Vue) {
    // Initialize Amplitude service
    AmplitudeService.init();

    // Add to Vue prototype for easy access in components
    Vue.prototype.$amplitude = AmplitudeService;

    // Add global mixin for automatic page tracking
    Vue.mixin({
      beforeRouteEnter(to, from, next) {
        next(() => {
          AmplitudeService.trackPageView(to.name || to.path);
        });
      },
      beforeRouteUpdate(to, from, next) {
        AmplitudeService.trackPageView(to.name || to.path);
        next();
      }
    });
  }
};
